export interface DashboardColumnTemplate {
  docketNumber: string;
  dateReceived: Date;
  typeOfFiling: string;
  agencyName: string;
  titleNumber: string;
  chapterNumber: string;
  dateAccepted: Date;
}

export const ConstructEmptyDashboardColumnTemplate : Function = () => {
  let template : DashboardColumnTemplate = {
    docketNumber: '',
    dateReceived: new Date(),
    typeOfFiling: '',
    agencyName: '',
    titleNumber: '',
    chapterNumber: '',
    dateAccepted: new Date(),
  };
  return template;
}
